<template>
  <div class="bordered">

    <div class="container-fill" @click="toggle">
      <div>{{ profile.name }} <span class="default" v-show="profile.default">(default)</span></div>
      <!-- <div>
        (alerts: {{ profile.total_alerts }}, keywords: {{ profile.total_keywords }})
      </div> -->
    </div>

    <div class="details" v-show="isActive">
      <div id="profileButtons" >
        <!-- <font-awesome-icon icon="trash" @click="deleteProfile()" title="Delete profile"/>         -->
        <button @click="resetProfile()">Reset</button>
        <button v-show="!profile.default" @click="deleteProfile()">Delete</button>
      </div>
      
      <table>
        <tr>
          <td>ID:</td>
          <td>{{ profile.id }}</td>
        </tr>
        <tr>
          <td>Type:</td>
          <td>{{profile.type}}</td>
        </tr>
        <tr>
          <td>Name:</td>
          <td><input type="text" v-model="profileName"/></td>
        </tr>
      </table>
      <button @click="cancel()">Cancel</button>
      <button @click="save()">Save</button>
    </div>

    <pre class="debug" v-show="debugMode">{{profile}}</pre>
  
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#profileButtons {
  display: inline-block;
  float: right;
}
.default {
  font-size: small;
}
.container {
  display: flex;
}
.container-fill {
  display: flex;
  justify-content: space-between;
}
.details {
  margin-top: 5px;
  border-top: 1px solid #cccccc;
  padding-top: 5px;
}
.details-header {
  font-size: small;
}
.details-header > h2,h3,h4 {
  font-size: initial;
  margin: 0px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  computed: mapState([
    'debugMode'
  ]),
  data () {
    return {
      isActive: false,
      profileName: this.profile.name
    }
  },
  methods: {
    toggle: function (event) {
      if (event.target.tagName != 'DIV' && event.target.tagName != 'SPAN') return
      this.isActive = !this.isActive
    },
    cancel () {
      this.profileName = this.profile.name
    },
    save () {
      var params = {}
      if (this.profileName !== this.profile.name) params['name'] = this.profileName
      this.$store.dispatch('updateProfile', {
        profile: this.profile, 
        params: params
      })
    },
    deleteProfile () {
      if (!confirm('Are you sure? This will delete the profile permanently!')) return
      this.$store.dispatch('deleteProfile', this.profile)
    },
    resetProfile () {
      if (!confirm('Are you sure? This will delete all the assets and alerts for this profile!')) return
      this.$store.dispatch('resetProfile', this.profile)
    }
  }
}
</script>
